import { c as _c } from "react/compiler-runtime";
import { ButtonProps } from '@systemeio/ui';
import React, { useState } from 'react';
import ConfirmationModal, { ConfirmationProps } from '.';
interface ConfirmationModalWithButtonProps extends Omit<ConfirmationProps, 'opened' | 'onClose'> {
  renderButton: (props: Pick<ButtonProps, 'onClick'>) => React.ReactNode;
}
function ConfirmationModalWithButton(t0) {
  const $ = _c(13);
  let props;
  let renderButton;
  if ($[0] !== t0) {
    ({
      renderButton,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = renderButton;
  } else {
    props = $[1];
    renderButton = $[2];
  }
  const [isOpened, setIsOpened] = useState(false);
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setIsOpened(true);
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== renderButton) {
    t2 = renderButton({
      onClick: t1
    });
    $[4] = renderButton;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setIsOpened(false);
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== isOpened || $[8] !== props) {
    t4 = <ConfirmationModal opened={isOpened} onClose={t3} {...props} />;
    $[7] = isOpened;
    $[8] = props;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t2 || $[11] !== t4) {
    t5 = <>{t2}{t4}</>;
    $[10] = t2;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}
export default ConfirmationModalWithButton;